import styled from 'styled-components'
import { Paper, TableCell, TableContainer } from '@material-ui/core'

export const RegistersContainer = styled(Paper)`
  padding: 1rem;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 4%);
  background-color: ${(props) => props.theme.palette.background.paper};

  div[role='tabpanel'] > div {
    height: auto;
    overflow: hidden;
  }
`

export const StyledTableContainer = styled(TableContainer)`
  position: relative;

  .MuiTableRow-root:nth-child(even) {
    background-color: ${(props) => props.theme.palette.grey[50]};
  }

  max-height: 60dvh;

  .MuiTable-stickyHeader {
    border-collapse: collapse;
  }
`

export const StyledTableCell = styled(TableCell)`
  color: ${(props) => props.theme.palette.grey[700]};
  border: 1px solid ${(props) => props.theme.palette.grey[200]};

  &.MuiTableCell-head {
    background-color: ${(props) => props.theme.palette.grey[100]};
    font-weight: bold;
  }
`
